import React, { useContext } from "react";
import moment from "moment";
import { ProyectosContext } from "../../context/ProyectosContext";
import { formatPct } from "../../utils";

export const INFO_FECHA_ESPERADA =
  "La fecha esperada asume que la obra mantiene su desempeño actual contra lo programado. Se calcula cada vez que se abre esta vista.";

const formatFecha = (fecha) =>
  fecha ? moment(fecha).format("DD MMM YYYY") : "-";

const Dato = ({ label, children, className = "" }) => (
  <div className="col-6 col-md-4 mb-3">
    <div className="small text-muted">{label}</div>
    <div className={`bold h5 mb-0 ${className}`}>{children}</div>
  </div>
);

// datos: proyeccion saved with a report; otherwise the one in context.
const FechaEsperadaTerminacion = ({ datos }) => {
  const { proyeccion: proyeccionObra } = useContext(ProyectosContext);
  const proyeccion = datos !== undefined ? datos : proyeccionObra;

  if (proyeccion === undefined) {
    return <div className="spinner-border spinner-border-sm m-3" />;
  }
  if (proyeccion === null) {
    return (
      <p className="text-muted px-3 mb-0">
        No hay suficiente información (fechas de partidas o avance) para
        proyectar la terminación.
      </p>
    );
  }

  const {
    fecha_fin_programada,
    fecha_fin_proyectada,
    dias_desviacion,
    real,
    programado,
    ritmo_actual_diario,
    avance_diario_requerido,
  } = proyeccion;

  const atrasada = dias_desviacion !== null && dias_desviacion > 0;
  const colorDesviacion =
    dias_desviacion === null ? "" : atrasada ? "text-danger" : "text-success";

  return (
    <div className="container-fluid px-3">
      <div className="row">
        <Dato label="Fecha fin programada">
          {formatFecha(fecha_fin_programada)}
        </Dato>
        <Dato label="Fecha esperada de terminación" className={colorDesviacion}>
          {formatFecha(fecha_fin_proyectada)}
        </Dato>
        <Dato label="Desviación" className={colorDesviacion}>
          {dias_desviacion === null
            ? "-"
            : dias_desviacion === 0
            ? "A tiempo"
            : `${Math.abs(dias_desviacion)} días ${
                atrasada ? "de atraso" : "antes"
              }`}
        </Dato>
        <Dato label="Avance real / programado a hoy">
          {formatPct(real)} / {formatPct(programado)}
        </Dato>
        <Dato label="Ritmo actual diario">
          {formatPct(ritmo_actual_diario, 2)}
        </Dato>
        <Dato label="Avance diario requerido para terminar a tiempo">
          {formatPct(avance_diario_requerido, 2)}
        </Dato>
      </div>
    </div>
  );
};

export default FechaEsperadaTerminacion;
